import React, { Fragment, useEffect, useState } from "react"
import { deleteBusta, fetchBusta, fetchBuste } from "../services/api"
import { gruppaBustePerMese } from "../utils"
import { Link } from "wouter"
import { CheckCircleIcon, PaperClipIcon, XCircleIcon, TrashIcon } from "@heroicons/react/24/outline"
import moment from "moment"
import Swal from 'sweetalert2'

export default function BusteDetail(props) {

  const { loading, token, resourceId }    = props
  const [busta, setBusta] = useState({})
  const [fetching, setFetching] = useState(true)

  const deleteIt = () => {
    // sweetalert confirmation
    Swal.fire({
      title: 'Sei sicuro di voler cancellare questo file?',
      text: "Una volta cancellato non sarai in grado di recuperare il file!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, sono sicuro!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        
        deleteBusta(token, resourceId).then((res) => {
          Swal.fire(
          'Cancellato!',
          'Il file è stato cancellato con successo.',
          'success'
        )
        // windows history back
        window.history.back()
        }).catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops... qualcosa è andato storto!',
            text: err.message,
          })
        })
      }
    })

  }

  useEffect(() => {
    if (token && !loading) {
      console.log(token)
      setFetching(true)
    }
    fetchBusta(token, resourceId)
      .then((res) => {
        setBusta(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])

  
  if (fetching) {
    return <div
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      <div role="status">
        <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
    </div>
  }

  return <div className="flex flex-wrap">
    <div className="w-full md:w-4/12">
      <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">

          <div className="px-4 py-6 sm:px-6">
            <h3 className="text-base font-semibold leading-7 text-gray-900">Informazioni</h3>
          </div>
          <div className="border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">Mese</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{busta.month}</dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">Anno</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{busta.year}</dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">Status</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {
                  busta.read_at ? (
                    <>
                      <CheckCircleIcon className="h-5 w-5 text-green-400" />
                      <span className="text-sm text-gray-500">
                        {/* format date */}
                        {moment(busta.read_at).format('DD/MM/YYYY HH:mm')}
                      </span> 
                    </>

                  ) : (
                    <>
                      <XCircleIcon className="h-5 w-5 text-red-400" />
                      
                    </>
                  )
                  }
                </dd>
              </div>
              {
                busta.net_amount != 0 && (
                  <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-900">Netto</dt>
                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{busta.net_amount }</dd>
                  </div>
                )
              }
              
            </dl>
          </div>
        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-900">Data Caricamento</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{moment(busta.created_at).format('DD/MM/YYYY HH:mm')}</dd>
        </div>

        <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-900">Azioni</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            <button onClick={deleteIt} className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
              <TrashIcon className="h-5 w-5 text-white" />
            </button>

          </dd>
        </div>
      </div>
    </div>
    <div className="w-full md:w-8/12">
      <div className="bg-white border border-gray-200 rounded-lg shadow ">
        {/* iframe completo */}
        <iframe src={busta?.file}
          title="YouTube video player" frameBorder="0"
          className="w-full h-screen" allowFullScreen></iframe>

      </div>
    </div>
  </div>
}